<template>
  <div
    id="nav-collapse"
    ref="collapseRef"
    class="
      relative z-10 w-full
      lg:absolute
    "
    :class="{'opacity-0': !isMounted}"
  >
    <div
      class="
        left-0 flex w-full flex-col items-center overflow-hidden bg-red-500
        text-left transition-[height]
        lg:shadow-md
      "
      :class="navigation.getOpen
        ? `duration-500 ease-out`
        : `h-0 duration-250 ease-in`"
      :style="navigation.getOpen ? `height: ${navigation.getHeight}px;` : ''"
    >
      <nav
        class="
          flex w-full grow flex-col items-start
          lg:max-w-[85rem]
        "
      >
        <NavItemsRecursive :items="globals?.main.tree ?? {}" />
      </nav>
    </div>
  </div>
</template>

<script lang="ts" setup>
const globals = inject(GlobalsKey)
const navigation = useNavigationStore()
const isMounted = ref(false)

const handleResizeStart = () => {
  navigation.setOpenState(false)
}

const handleResizeDebounced = useDebounceFn(() => {
  navigation.setHeight(0)
}, 200)

const handleResize = () => {
  handleResizeStart()
  handleResizeDebounced()
}

onMounted(() => {
  isMounted.value = true // prevent visibility on load

  window.addEventListener('resize', handleResize)
})
</script>
